import { FC, useCallback, useEffect, useState } from 'react';

import { useUserContext } from '../../contexts/user_context';
import leaderboard_service, { Leaderboard } from '../../services/leaderboard_service';

import './leaderboard_page.css';

export const LeaderboardPage: FC = () => {
    const [leaderboard, set_leaderboard] = useState<Leaderboard[]>([]);
    const { access_token } = useUserContext();

    const fetch_leaderboard = useCallback(async () => {
        if (!access_token) return;
        const data = await leaderboard_service.get(access_token);
        if (!data) return;
        set_leaderboard(data.sort((a, b) => b.xp - a.xp));
    }, [access_token]);

    useEffect(() => {
        if (leaderboard.length === 0) {
            fetch_leaderboard();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [leaderboard.length,access_token]);

    return (
        <div className='leaderboard-page'>
            <div className='text-container'>
                <h2>🏆 All-Time Legends – Hall of Fame!</h2>
                <p>Welcome to the leaderboard! The most dedicated and successful participants of all time are honored here. Compete and secure your place among the best! 🚀🔥</p>
            </div>
            <div className='leaderboard'>
                <div className='leaderboard-row'>
                    <div className='leaderboard-cell'>#</div>
                    <div className='leaderboard-cell'>Name</div>
                    <div className='leaderboard-cell'>Points</div>
                </div>

                {leaderboard.map((row, index) => (
                    <div key={index} className='leaderboard-row'>
                        <div className='leaderboard-cell'>{index + 1}</div>
                        <div className='leaderboard-cell'>{row.name}</div>
                        <div className='leaderboard-cell'>{String(row.xp)}</div>
                    </div>
                ))}
            </div>
        </div>
    );
};
